<template>
    <div :class="['badge', 'company-badge', size]">
        <div class="avatar-container">
            <router-link :to="to">
                <CompanyAvatar :company="company" :size="size" />
            </router-link>
        </div>
        <div class="title">
            <CompanyLink :company="company" :query="query" :symbol="symbol" :hidePopover="hidePopover" />
            <CeoChangeLogo
                v-if="company.ceoChangeReportAvailableForEntity"
                :class="`verified inline ${ceoChangeLogoSize}`"
            />
        </div>
        <div class="subtitle" v-if="symbol">
            <CompanyLink :company="company" :query="query" type="tertiary-link" :hidePopover="hidePopover" />
        </div>
    </div>
</template>
<script>
import CeoChangeLogo from '@/components/ceo-change/logo'
import CompanyAvatar from '@/components/companies/avatar'
import CompanyLink from '@/components/companies/CompanyLink'

export default {
    components: {
        CeoChangeLogo,
        CompanyAvatar,
        CompanyLink,
    },
    props: {
        company: {
            type: Object,
            required: true,
        },
        hidePopover: {
            type: Boolean,
            default: false,
        },
        query: {
            type: Object,
            required: false,
            default() {
                return null
            },
        },
        size: {
            type: String,
            default: 'small',
        },
        symbol: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ceoChangeLogoSize() {
            return this.size === 'medium' ? 'md' : 'xs'
        },
        to() {
            return { name: 'company-page', params: { id: this.company.id } }
        },
    },
}
</script>
